import { z } from 'zod';

export enum Feedback {
  Bug = 'bug',
  Feature = 'feature',
  Other = 'other',
  AccountDeletion = 'account_deletion',
  SubscriptionCancellation = 'subscription_cancellation',

  CalendarIssue = 'calendar_issue',
}

export type CalendarIssueType =
  | 'event_missing'
  | 'event_incorrect'
  | 'dates_wrong'
  | 'other';

export type FeedbackType = `${Feedback}`;

export const FeedbackResponseSchema = z.object({
  status: z.enum(['success', 'error']),
  message: z.string().optional(),
});

export type FeedbackResponse = z.infer<typeof FeedbackResponseSchema>;
